import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';

interface Tradutor {
  id: number;
  nomeCompleto: string;
  cpf: string;
  email: string;
  telefone: string;
  endereco: string;
  traducaoItalianoPortugues: boolean;
  traducaoPortuguesItaliano: boolean;
  traducaoOutras: boolean;
  outrasTraducoes?: string;
  juramentado: boolean;
}

@Component({
  selector: 'app-cadastro-tradutor',
  templateUrl: './cadastro-tradutor.component.html',
  styleUrls: ['./cadastro-tradutor.component.scss']
})
export class CadastroTradutorComponent implements OnInit {
  cadastroForm: FormGroup;
  tradutores: any[] = [];
  tradutoresFiltrados: any[] = [];
  modalRef: NgbModalRef;
  outrasTraducoes: string = '';
  tradutorSelecionado: any;
  loading: boolean = false;

  // Propriedades para filtros
  filtroNome: string = '';
  filtroCpf: string = '';
  filtroTraducao: string = '';
  filtroJuramentado: string = '';

  // Máscaras para os campos
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  telefoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private ajaxService: AjaxService
  ) {
    this.cadastroForm = this.fb.group({
      id: [''],
      nomeCompleto: ['', Validators.required],
      cpf: ['', [Validators.required, Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)]],
      email: ['', [Validators.required, Validators.email]],
      telefone: ['', Validators.required],
      endereco: ['', Validators.required],
      ITA_POR: [false],
      POR_ITA: [false],
      OUT: [false],
      juramentado: [false],
      outrasTraducoes:[''],
    });
  }

  ngOnInit() {
    this.carregarTradutores();
  }

  carregarTradutores() {
    this.loading = true;
    let url = API + "UsuarioTradutor/UsuarioTradutor";
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.tradutores = response.data;
        this.tradutoresFiltrados = [...this.tradutores];
        this.loading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar tradutores:', error);
        this.loading = false;
      }
    });
  }

  aplicarFiltros() {
    this.tradutoresFiltrados = this.tradutores.filter(tradutor => {
      const matchNome = !this.filtroNome || 
        tradutor.nome.toLowerCase().includes(this.filtroNome.toLowerCase());
      
      const matchCpf = !this.filtroCpf || 
        tradutor.cpf.includes(this.filtroCpf);
      
      const matchTraducao = !this.filtroTraducao || 
        tradutor[this.filtroTraducao];
      
      const matchJuramentado = !this.filtroJuramentado || 
        tradutor.juramentado === this.filtroJuramentado;

      return matchNome && matchCpf && matchTraducao && matchJuramentado;
    });
  }

  limparFiltros() {
    this.filtroNome = '';
    this.filtroCpf = '';
    this.filtroTraducao = '';
    this.filtroJuramentado = '';
    this.tradutoresFiltrados = [...this.tradutores];
  }

  openModal(content: any, limparform=false): void {

    debugger
    if(limparform){
      this.tradutorSelecionado = null;
      this.cadastroForm.patchValue({
        id: "",
        nomeCompleto: "",
        cpf: "",
        email: "",
        telefone: "",
        endereco: "",
        ITA_POR: false,
        POR_ITA: false,
        OUT: false,
        juramentado: "N",
        outrasTraducoes: ""
      });
    }
     
    this.modalRef = this.modalService.open(content, { size: 'lg' });
  }

  onSubmit() {
    if (this.cadastroForm.valid) {
      const formData = this.cadastroForm.value;
      if (this.outrasTraducoes) {
        formData.outrasTraducoes = this.outrasTraducoes;
      }

      let dados = {        
        "NOME": formData.nomeCompleto,
        "CPF": formData.cpf,
        "EMAIL": formData.email,
        "TELEFONE": formData.telefone,
        "ENDERECO": formData.endereco,
        "TRAD_ITALIANO_PORTUGUES": formData.ITA_POR,
        "TRAD_PORTUGUES_ITALIANO":formData.POR_ITA,
        "TRAD_OUTRAS":formData.OUT,
        "JURAMENTADO": formData.juramentado ? "S" : "N",
        "OUTRAS_OBS": formData.outrasTraducoes
      }

      if (this.tradutorSelecionado != null) {
        debugger
        let url = API + "Usuario/Usuario/tradutor";
        dados["ID_USUARIO_TRADUTOR"] =  this.tradutorSelecionado.iD_USUARIO_TRADUTOR;
        dados["ID_USUARIO"] = this.tradutorSelecionado.iD_USUARIO;
        // Atualizar tradutor existente
        this.ajaxService.post(url, dados).subscribe({
          next: (response) => {
            this.carregarTradutores();
            this.modalRef.dismiss();
            this.cadastroForm.reset();
          },
          error: (error) => {
            console.error('Erro ao atualizar tradutor:', error);
          }
        });
      } else {
        debugger
        let url = API + "Usuario/Usuario/tradutor";
        // Criar novo tradutor
        this.ajaxService.post(url, dados).subscribe({
          next: (response) => {
            this.carregarTradutores();
            this.modalRef.dismiss();
            this.cadastroForm.reset();
          },
          error: (error) => {
            console.error('Erro ao criar tradutor:', error);
          }
        });
      }
    }
  }

  editarTradutor(tradutor: any) {
    debugger
    this.tradutorSelecionado = tradutor;
    this.outrasTraducoes = tradutor.outraS_OBS;
    this.cadastroForm.patchValue({
      id: tradutor.id,
      nomeCompleto: tradutor.nome,
      cpf: tradutor.cpf,
      email: tradutor.email,
      telefone: tradutor.telefone,
      endereco: tradutor.endereco,
      ITA_POR: tradutor.traD_ITALIANO_PORTUGUES,
      POR_ITA: tradutor.traD_PORTUGUES_ITALIANO,
      OUT: tradutor.traD_OUTRAS,
      juramentado: tradutor.juramentado == "S"? true : false,
      outrasTraducoes: tradutor.outraS_OBS
    });
    
   
  }

  excluirTradutor(id: number) {
    if (confirm('Tem certeza que deseja excluir este tradutor?')) {
      this.ajaxService.delete(`Usuario/Usuario/tradutor/${id}`).subscribe({
        next: () => {
          this.carregarTradutores();
        },
        error: (error) => {
          console.error('Erro ao excluir tradutor:', error);
        }
      });
    }
  }
} 